import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

export default _.merge({
  messages: {
    'es-MX': {
        forbidden: 'Acceso no autorizado.',
    },
    en: {
      forbidden: 'Unauthorized access.',
    }
  }
}, defaultMessages)
